<template>
    <div class="row button-question">
        <div class="col-xl-3 col-xxl-2 question-label">{{label}}</div>
        <div class="col-xl-7 col-xxl-8 question">
            <div class="row row-cols-3">
                <div v-for="(val, index) in values" class="col button-holder" :key="index">
                    <button type="button" class="btn" :class="{ 'btn-success': val.value === currentValue, 'btn-outline-dark': val.value !== currentValue}" @click="setValue(val.value)" :disabled="!allowChange">{{val.label}}</button>
                </div>
            </div>
        </div>
        <div class="col-2 question-error">
          {{errors}}
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import LabelFilledMixin from './LabelFilledPlaceholdersComputedMixin'

export default {
  name: 'OptionButtons',
  props: ['question', 'modelValue', 'errors', 'default', 'allowChange'],
  mixins: [LabelFilledMixin],
  emits: ['update:modelValue'],
  data () {
    return {
      values: []
    }
  },
  computed: {
    currentValue: {
      get () {
        return typeof this.modelValue !== 'undefined' ? this.modelValue : null
      },
      set (newValue) {
        this.$emit('update:modelValue', newValue)
      }
    },
    placeholder () {
      return this.question.placeholder
    },
    ...mapGetters({
      leadInfo: 'consumer/lead/leadInfo'
    })
  },
  methods: {
    setValue (val) {
      this.currentValue = val
    },
    setValues (newValues) {
      this.values = this.default && this.question.dependsOn ? newValues.filter((v) => v.value !== this.default) : newValues
    }
  },
  mounted () {
    this.setValues(this.question.values)
  },
  watch: {
    'question.values' (newList) {
      this.setValues(newList)
    }
  }
}
</script>

<style scoped>
.button-holder {
  margin-bottom: 10px;
}
.button-holder button {
  width: 100%;
  font-size: 12px;
  padding: 5px 10px;
}
</style>
